'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsToStyleString = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _keys = require('babel-runtime/core-js/object/keys');
var _keys2 = _interopRequireDefault(_keys);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n'], ['\n  ', '\n']);
var _styledComponents = require('styled-components');
var _unit = require('./unit');
var _unit2 = _interopRequireDefault(_unit);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var nuggets = [2, 4, 8, 16, 24, 32, 64, 128];
var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'top',
  r: 'right',
  b: 'bottom',
  l: 'left'
};
var PropsToStyleString = exports.PropsToStyleString = function PropsToStyleString(props) {
  return (0, _keys2.default)(properties).map(function (propertyKey) {
    return (0, _keys2.default)(directions).map(function (directionKey) {
      var propKey = '' + propertyKey + directionKey;
      if (props[propKey]) {
        var nuggetIndex = props[propKey];
        var cssAttr = properties[propertyKey] + '-' + directions[directionKey];
        return cssAttr + ': ' + (nuggets[nuggetIndex] + _unit2.default) + ';';
      }
      return '';
    });
  });
};
exports.default = (0, _styledComponents.css)(_templateObject, function (props) {
  return PropsToStyleString(props);
});